import { render, staticRenderFns } from "./AdminCustomerToggle.vue?vue&type=template&id=0c33f11f"
import script from "./AdminCustomerToggle.vue?vue&type=script&lang=js"
export * from "./AdminCustomerToggle.vue?vue&type=script&lang=js"
import style0 from "./AdminCustomerToggle.vue?vue&type=style&index=0&id=0c33f11f&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports